module.exports = __webpack_public_path__ + "static/img/channel_talk.ad1c38c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channel_talk.png
// module id = hp9w
// module chunks = 1